import {MarketStatsStyles} from "../../charts/MarketStatsChart";
import {MarketStats} from "./MarketStats";

export class MarketStatsInitializer {
    private readonly element: HTMLElement | undefined;
    private readonly stylesGenerator: (device: string) => MarketStatsStyles;

    constructor(stylesGenerator: (device: string) => MarketStatsStyles) {
        this.stylesGenerator = stylesGenerator;
        this.element = document.querySelector('.js-market-stats') as HTMLElement
    }

    init() {
        if (this.element) {
            new MarketStats().init(this.getMarketStatsStyles())
        }
    }

    private getMarketStatsStyles() {
        return this.stylesGenerator(this.getDevice());
    }

    private getDevice(): string {
        let device = this.element!.dataset.d;
        if (device) {
            return device;
        }
        return "DESKTOP";
    }
}